import script from "./TableItem.vue?vue&type=script&setup=true&lang=js"
export * from "./TableItem.vue?vue&type=script&setup=true&lang=js"

import "./TableItem.vue?vue&type=style&index=0&id=06773cd2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06773cd2"]])

export default __exports__